import { batch } from "react-redux";

import {
  SetCustomOperationContentChanged,
  SetCustomOperationFileName,
  SetCustomOperationPreloaded,
  SetCustomOperationRepeatValue,
  showAlert,
  UpdateOperationList,
} from "@/actions/setupActions";
import {
  getDetailSequence,
  getListManualProfiles,
  postSaveSeqDesignerDevice,
  setFavoriteSequence,
} from "@/api/deviceApi";
import { ALERT_TYPE } from "@/constants/enums";
import { formatMessage } from "@/libs/intlHelper";

// eslint-disable-next-line import/prefer-default-export
export function saveManualProfile(fileName, saveAs, operations) {
  return async (dispatch, getState) => {
    try {
      const { setupStore } = { ...getState() };
      const { CustomOperation } = setupStore;

      const customOperations = [...CustomOperation.Operations]?.map(
        (operation, index) => ({
          ...operation,
          Repeat: operations[index].TempRepeat ?? operations[index].Repeat,
        })
      );

      const response = await postSaveSeqDesignerDevice(
        CustomOperation.Repeat,
        customOperations,
        fileName,
        saveAs
      );

      if (!response.data && saveAs) {
        dispatch(
          showAlert({
            alertShow: true,
            alertText: formatMessage({
              id: "toast.manualProfile.failedNameExist.message",
            }),
            alertStyle: ALERT_TYPE.ALERT_DANGER,
          })
        );
      } else {
        batch(() => {
          const FileName = `${fileName}.json`;
          dispatch(fetchManualProfile(FileName));
        });
      }
    } catch (error) {
      console.log("saveManualProfile error", error);
    }
  };
}

export const fetchManualProfile = (fileName) => async (dispatch) => {
  try {
    const response = await getDetailSequence(fileName);

    if (response) {
      const { data } = response;
      batch(() => {
        dispatch(SetCustomOperationFileName(data.FileName));
        dispatch(SetCustomOperationRepeatValue(data.Repeat));
        dispatch(SetCustomOperationPreloaded(data.IsPreloaded));
        dispatch(UpdateOperationList(data.Operations));
        dispatch(SetCustomOperationContentChanged(false));
      });
    }
  } catch (error) {
    console.log("fetchManualProfile error", error);
  }
};

// eslint-disable-next-line consistent-return
export const fetchListManualProfiles = async () => {
  try {
    const response = await getListManualProfiles();
    return response;
  } catch (error) {
    console.log("fetchListManualProfiles error", error);
  }
};

// eslint-disable-next-line consistent-return
export const setFavoriteManualProfile = async (param) => {
  try {
    const response = await setFavoriteSequence(param);
    return response;
  } catch (error) {
    console.log("fetchFavoriteSequence error", error);
  }
};
